import { Flex } from 'antd';
import { Link } from 'react-router-dom';

import CreatorAvatar from '@/components/common/CreatorAvatar';
import { formatNumber } from '@/lib/helpers/formatNumber';
import { formatSecondsToTime } from '@/lib/helpers/formatSecondsToTime';
import getPlatformFromUrl from '@/lib/helpers/getPlatformFromUrl';
import { ICategoryCreator } from '@/ts';

import { PLATFORMS } from '../../../../../../const/index';
import Platforms from '../../../creators/platforms';

const columns = [
	{
		title: 'Name',
		dataIndex: 'profileName',
		key: 'profileName',
		sorter: true,
		editable: false,
		width: 200,
		flex: true,
		// sortOrder: 'descend',
		ellipsis: true,
		render: (_: any, record: ICategoryCreator) => {
			const queryParams = new URLSearchParams(window.location.search);

			return (
				<Flex gap={8}>
					<Link
						to={`/app/dashboard/video-intelligence-lake/${record?.category_id}/creators/${record._id}`}
						style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
						onClick={() => {
							localStorage.setItem(
								'category_page',
								queryParams.get('page')?.toString() || '1',
							);
						}}
					>
						<CreatorAvatar record={record} />
						{record?.profileName ||
							record?.platformHandles?.[0]?.replace('https://www.', '')}
					</Link>
				</Flex>
			);
		},
	},
	{
		title: 'Platform',
		dataIndex: 'platform',
		key: 'platform',
		// sorter: true,
		filters: PLATFORMS,
		editable: false,
		width: 90,
		align: 'center',

		// ellipsis: true,
		render: (_: any, record: ICategoryCreator) => {
			const platforms =
				Object.values(record?.platforms ?? {})?.filter((item) => !!item)
					?.length === 0
					? record?.platformHandles.reduce(
							(acc: { platform: string; url: string }[], value) => {
								if (value !== null) {
									const platform = getPlatformFromUrl(value);
									if (platform && platform?.name) {
										acc.push({ platform: platform?.name!, url: value });
									}
								}
								return acc;
							},
							[],
					  )
					: Object.entries(record?.platforms).reduce(
							(acc: { platform: string; url: string }[], [key, value]) => {
								if (value !== null) {
									acc.push({ platform: key, url: value?.url });
								}
								return acc;
							},
							[],
					  );

			return (
				<div
					style={{
						display: 'flex',
						gap: '0.375rem',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					{platforms?.length > 0 ? (
						platforms.map((item) => (
							<Link
								key={item?.platform}
								to={item?.url}
								target="_blank"
								title={item?.platform}
								style={{
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
								}}
							>
								<Platforms platform={item?.platform} />
							</Link>
						))
					) : (
						<div>-</div>
					)}
				</div>
			);
		},
	},
	{
		title: 'Followers',
		dataIndex: 'followers',
		key: 'followers',
		editable: false,
		width: 100,
		align: 'center',
		// ellipsis: true,
		render: (_: any, record: ICategoryCreator) => {
			const dataArr = record?.platforms
				? Object.entries(record?.platforms)?.reduce(
						(
							acc: {
								platform: string;
								subscribers?: string;
								followers?: string;
							}[],
							[key, value],
						) => {
							if (
								value !== null &&
								(value?.connections?.subscribers ||
									value?.connections?.followers)
							) {
								acc.push({
									platform: key,
									subscribers:
										value?.connections?.subscribers ??
										value?.connections?.followers,
								});
							}

							return acc;
						},
						[],
				  )
				: [];

			if (dataArr.length === 0) {
				return <div>-</div>;
			}

			return (
				<ul
					style={{
						display: 'flex',
						flexDirection: 'column',
						padding: 0,
					}}
				>
					{dataArr.map(({ platform, subscribers }) => (
						<li key={platform} style={{ listStyle: 'none', padding: 0 }}>
							{subscribers && formatNumber(subscribers)}
						</li>
					))}
				</ul>
			);
		},
	},
	{
		title: 'Videos',
		dataIndex: 'videoQuantity',
		key: 'videoQuantity',
		width: 100,
		sorter: true,
		editable: false,
		align: 'center',

		render: (_: any, record: ICategoryCreator) => {
			return !record?.videoQuantity ? '-' : record?.videoQuantity;
			// return record.;
		},
	},
	{
		title: 'Content duration',
		width: 100,
		dataIndex: 'videoDuration',
		key: 'videoDuration',
		sorter: true,
		editable: false,
		render: (_: any, record: ICategoryCreator) => {
			return !record?.videoDuration
				? '-'
				: formatSecondsToTime(record?.videoDuration);
			// return record.;
		},
		// width: 160,
	},
];

export { columns };
